module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.reportStatus,
      "height": "355",
      "id": "assoc-table"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Report Date",
      "prop": "date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Download Report"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "round": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDownload(props.row.date)
            }
          }
        }, [_vm._v("Download")])]
      }
    }])
  })], 1), _vm._v(" "), _c('hr')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Admin Reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d8d3fcf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/reports/BidderRevenueReports.vue
// module id = 690
// module chunks = 2